import { rest } from 'msw';
import updatePasswordPath from 'consts/paths/api/auth/updatePassword';
import resolvePath from '../../resolvePath';

export default ({ delay = 0 } = {}) => [
    rest.post(resolvePath(updatePasswordPath), (req, res, ctx) => res(ctx.delay(delay), ctx.status(200), ctx.json({}))),
];
